import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-enterprise';
import { CalendarMonth, fromDateOnlyString, isDateOnlyString, toDateOnlyString } from '../../../core/date';

export const valueGetters = {
    boolean: (fieldName: string): ValueGetterFunc => {
        return (params: ValueGetterParams): boolean => {
            const rawValue = params.data?.[fieldName];

            if (rawValue === true || rawValue === 'true' || rawValue === 1 || rawValue === '1') {
                return true;
            }

            return false;
        };
    },

    date: (fieldName: string): ValueGetterFunc => {
        return (params: ValueGetterParams): Date | null => {
            const rawValue = params.data?.[fieldName];

            if (!rawValue) {
                return null;
            }

            let date: Date | null = null; 
            if (isDateOnlyString(rawValue)){
                date = fromDateOnlyString(rawValue);
            }
            else {
                /* Assume we are getting a DateTime. Convert to Date Only */
                const dateTime = new Date(rawValue);
                const dateOnly = toDateOnlyString(dateTime);
                date = fromDateOnlyString(dateOnly);
            }

            if (!date) {
                return null;
            }
            return date;
        };
    },

    dateTime: (fieldName: string): ValueGetterFunc => {
        return (params: ValueGetterParams): Date | null => {
            const rawValue = params.data?.[fieldName];

            if (!rawValue) {
                return null;
            }

            const date = new Date(rawValue);

            return date;
        };
    },

    dateYear: (fieldName: string): ValueGetterFunc => {
        return (params: ValueGetterParams): number | null => {
            const rawValue = params.data?.[fieldName];

            if (!rawValue) {
                return null;
            }

            let date: Date | null = null; 
            if (isDateOnlyString(rawValue)){
                date = fromDateOnlyString(rawValue);
            }
            else {
                date = new Date(rawValue);
            }
            
            if (!date) {
                return null;
            }

            return date?.getFullYear();
        };
    },

    dateMonth: (fieldName: string): ValueGetterFunc => {
        return (params: ValueGetterParams): string | null => {
            const rawValue = params.data?.[fieldName];

            if (!rawValue) {
                return null;
            }

            let date: Date | null = null; 
            if (isDateOnlyString(rawValue)){
                date = fromDateOnlyString(rawValue);
            }
            else {
                date = new Date(rawValue);
            }

            if (!date) {
                return null;
            }

            const monthKey = date.getMonth() + 1;

            return CalendarMonth[monthKey];
        };
    },

    percentageFromFraction: (fieldName: string): ValueGetterFunc => {
        return (params: ValueGetterParams): number | null => {
            const rawValue = params.data?.[fieldName];

            if (!rawValue) {
                return null;
            }

            return rawValue * 100
        }
    }, 
};
